module.exports = __webpack_public_path__ + "img/fondo-banner-principal.b40dae81.png";